package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Finance_account(
  public val id: String,
  public val name: String,
  public val type: String,
  public val currency: String,
  public val balance: Long,
  public val icon: String,
  public val color: String,
  public val bank: String?,
  public val last4: String?,
  public val low_threshold: Long?,
  public val high_threshold: Long?,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
